const EmployeeCandidateDisclosure = () => (
  <div>
    <p>
      <strong>
        6698 SAYILI KİŞİSEL VERİLERİN KORUNMASI KANUNU (&ldquo;KVKK&rdquo;) USUL VE ESASLARI UYARINCA KİŞİSEL
        VERİLERİNİZİN KORUNMASI HAKKINDA
        <br />
        &nbsp;&Ccedil;ALIŞAN ADAYI AYDINLATMA METNİ
      </strong>
    </p>
    <p>
      Bu Aydınlatma Metni, 6698 sayılı Kişisel Verilerin Korunması Kanununun 10. maddesi ile Aydınlatma
      Y&uuml;k&uuml;ml&uuml;l&uuml;ğ&uuml;n&uuml;n Yerine Getirilmesinde Uyulacak Usul ve Esaslar Hakkında Tebliğ
      kapsamında veri sorumlusu sıfatıyla Emlakjet A.Ş (&ldquo;Şirket&rdquo;) tarafından &Ccedil;alışan Adayı&rsquo;nın
      hangi kişisel verilerini ne ama&ccedil;larla işleyeceğimizi anlatabilmek amacıyla hazırlanmıştır.&nbsp;
    </p>
    <p>
      Veri sorumlusu sıfatıyla aşağıda belirtilen şekillerde elde ettiğimiz kişisel verilerinizin, hukuki ilişkimiz
      kapsamında;&nbsp;
    </p>
    <ul>
      <li>
        İşlenmelerini gerektiren ama&ccedil; &ccedil;er&ccedil;evesinde ve bu ama&ccedil;la ile bağlantılı, sınırlı ve
        &ouml;l&ccedil;&uuml;l&uuml; şekilde,
      </li>
      <li>
        Tarafımıza bildirdiğiniz veya bildirildiği şekliyle kişisel verilerin doğruluğunu ve en g&uuml;ncel halini
        koruyarak,&nbsp;
      </li>
    </ul>
    <p>
      Kaydedileceğini, depolanacağını, muhafaza edileceğini, yeniden d&uuml;zenleneceğini, kanunen bu kişisel verileri
      talep etmeye yetkili olan kurumlar ile paylaşılacağını ve KVKK&apos;nın &ouml;ng&ouml;rd&uuml;ğ&uuml; şartlarda,
      yurti&ccedil;i veya yurtdışı &uuml;&ccedil;&uuml;nc&uuml; kişilere ve şirketin tedarik&ccedil;i ile şirketin
      iştiraklerine &ouml;zellikle grup şirketleri Cimri Bilgi Teknolojileri ve Sistemleri; Kariyernet A.Ş; Lityum
      Yazılım A.Ş; Endeksa Teknoloji A.Ş; Sigortamnet A.Ş.; Arabam com A.Ş.; Hangisi İnternet A.Ş.; Neredekal A.Ş. ;
      Chemorbis A.Ş.; Steelorbis A.Ş.; Hangikredi Sigorta A.Ş. ; Say Holding A.Ş.; Mesay Gayrimenkul A.Ş.; Olgun
      &Ccedil;elik A.Ş.; Tuzla Gayrimenkul A.Ş aktarılabileceğini, devredileceğini, sınıflandırılabileceğini ve
      KVKK&apos;da sayılan sair şekillerde işlenebileceğini bildiririz.
      <br />
      <br />
      <br />
      <strong>HANGİ KİŞİSEL VERİLERİNİZİ İŞLİYORUZ?</strong>
      &nbsp;
      <br />
      <br />
      İşlemeye konu olabilecek kişisel verileriniz aşağıdaki gibidir:
    </p>
    <ul>
      <li>Kimlik Verisi; Ad, Soyad, Doğum Yeri, Doğum Tarihi, Cinsiyet, Medeni Durum, Milliyet</li>
      <li>İletişim Verisi; Telefon Numarası, Adres Bilgileri, E-Posta Adresi</li>
      <li>
        &Ouml;zel Nitelikli Kişisel Veri; Dernek/vakıf &Uuml;yelikleri, Engelli Olma Durumu, Kan Grubu, Sigara Kullanımı
      </li>
      <li>
        Eğitim Verisi; &Ouml;ğrenim Durumu, Sertifika ve Diploma Bilgileri, Yabancı Dil Bilgisi, Katıldığı Seminer ve
        Kurslar, Eğitim ve beceriler,&nbsp;&nbsp;Bilgisayar Kullanma Yetisi
      </li>
      <li>
        İş Deneyimi Verisi; &Ccedil;alışma Durumu, Unvan, İş Tanımı, &Ccedil;alıştığı/&Ccedil;alışmış Olduğu Firma
        Bilgisi, Toplam tecr&uuml;besi
      </li>
      <li>G&ouml;rsel ve İşitsel Veri; Ger&ccedil;ek kişiye ait fotoğraf, selvi (video CV), kamera kayıtları</li>
    </ul>
    <p>
      Diğer; S&uuml;r&uuml;c&uuml; Belgesi, Yetkinlikler, Hobiler, Maaş Beklentisi, Askerlik Durumu, Referans Bilgileri
      (referans kişisinin adı soyadı, unvanı, işyeri, telefonu, e-postası) ve varsa CV&apos;ye eklenen her
      t&uuml;rl&uuml; word, excel, sunum dosyaları
      <br />
      <br />
    </p>
    <p>
      <strong>KİŞİSEL VERİLERİNİZİ NE ŞEKİLDE VE HANGİ SEBEPLERLE TOPLUYORUZ?</strong>
    </p>
    <p>
      Şirket ile aranızda kurulması hedeflenen hukuki ilişki &ccedil;er&ccedil;evesinde iş s&ouml;zleşmesinin kurulması
      i&ccedil;in gerekli olması nedeniyle ve Şirket&apos;in meşru menfaati gereği sizden talep ettiğimiz kişisel
      verilerinizi, sizin bize s&ouml;zl&uuml;, fiziksel veya elektronik ortamda iletmeniz yoluyla ve referans kİŞisİ
      g&ouml;stermeniz halinde bu kişilerden bilgi almak veya başvurunuz &ouml;ncesi &ccedil;alıştığınız işyerinin
      temsilcilerinden bilgi almak suretiyle topluyoruz.
    </p>
    <p>
      Kariyer.net, Linkedin vb istihdam platformlarında paylaştığınız kişisel verilerinizi bize platformlar
      &uuml;zerinden iş başvurusu yapmanız yoluyla veya platformlar &uuml;zerinde yayınladığınız bilgileri 3.kişilerle
      paylaşma tercihlerinize g&ouml;re iş s&ouml;zleşmesinin kurulabilmesi i&ccedil;in gerekli olması nedeniyle
      topluyoruz.
    </p>
    <p>
      Şirket&apos;in g&uuml;venliği sağlamaya y&ouml;nelik meşru menfaati gereği Şirket&apos;e yerleştirdiğimiz
      kameralar yoluyla g&ouml;rsel verilerinizi topluyoruz.
      <br />
      <br />
    </p>
    <p>
      <strong>KİŞİSEL VERİLERİNİZİN İŞLENME AMA&Ccedil;LARI</strong>
    </p>
    <p>
      Yukarıda belirttiğimiz kişisel verileriniz Şirket ile &Ccedil;alışan Adayı arasında kurulan &ccedil;alışan adayı-
      işveren adayı hukuki ilişkisi &ccedil;er&ccedil;evesinde iş s&ouml;zleşmesinin kurulması i&ccedil;in gerekli
      olması nedeniyle aşağıdaki ama&ccedil;larla işlenmektedir:
      <br />
      &nbsp; &nbsp;&nbsp;
    </p>
    <ul>
      <li>Yeni eleman istihdam edilmesi, adayları inceleme ve istihdam edilecek yeni adayın tespit edilmesi</li>
      <li>
        &Ouml;zge&ccedil;mişinizde yer verdiğiniz referans kişileriyle tarafınıza ait verilerin ve bilgilerin teyit
        edilmesi
      </li>
      <li>
        Aday olunan pozisyonla ne kadar &ouml;rt&uuml;şt&uuml;ğ&uuml;n&uuml;z&uuml;n doğrulanması ve ileriye
        d&ouml;n&uuml;k teyit i&ccedil;in &ouml;zge&ccedil;miş bilgilerinizin kaydedilmesi
      </li>
      <li>Şirket i&ccedil;erisinde g&uuml;venliğin sağlanması</li>
      <li>Şirket işyeri binası &ccedil;alışanın giriş &ccedil;ıkışının temin edilmesi</li>
      <li>
        Resepsiyon işlerinin y&uuml;r&uuml;t&uuml;lmesi ve İnsan Kaynakları ve Eğitim Departmanı&apos;nın
        bilgilendirilmesi
      </li>
      <li>
        Kişisel verileriniz, ilgili mevzuatta belirtilen veya işlendikleri ama&ccedil; i&ccedil;in gerekli olan azami
        s&uuml;re ve herhalde kanuni zamanaşımı s&uuml;releri kadar muhafaza edilecektir.
        <br />
      </li>
    </ul>
    <p>
      <br />
    </p>
    <p>
      <strong>&Ouml;ZEL NİTELİKLİ KİŞİSEL VERİLERİNİZ</strong>
    </p>
    <p>
      Zaman zaman bizimle paylaştığınız bilgiler, &ouml;zel nitelikli kişisel verinizi i&ccedil;erebilmektedir. KVKK
      kapsamında, ırkınıza, etnik k&ouml;keninize, siyasi d&uuml;ş&uuml;ncenize, felsefi inancınıza, dini, mezhebi veya
      diğer inan&ccedil;larınıza, kılık ve kıyafetinize, dernek, vakıf ya da sendika &uuml;yeliklerinize, sağlığınız,
      cinsel hayatınız, varsa ceza mahk&uuml;miyetinize ve hakkınızdaki g&uuml;venlik tedbirleriyle ilgili verileriniz
      ile biyometrik ve genetik verileriniz sizin &ouml;zel nitelikli verilerinizdir.
    </p>
    <p>
      Sizden &ouml;zellikle istemediğimiz s&uuml;rece, paylaştığınız &ouml;zge&ccedil;mişlerinizin i&ccedil;erisinde,
      profil sayfanızda veya bizimle yaptığınız destek g&ouml;r&uuml;şmelerinde &ouml;zel nitelikli kişisel
      verilerinizipaylaşmamanızı &ouml;neririz. Bu bağlamda &ouml;zel nitelikli kişisel verileriniz;
    </p>
    <ul>
      <li>
        Varsa fotoğrafınızla y&uuml;klediğiniz &ouml;zge&ccedil;miş ve &ouml;zge&ccedil;mişiniz i&ccedil;inde yer
        alabilecek dernek, vakıf &uuml;yeliği, engellilik durumu, kan grubu gibi &ouml;zel nitelikli verileriniz
        başvurunuzun değerlendirilebilmesini sağlamak amacıyla Şirket i&ccedil;erisinde yer alan farklı birimlerimiz
        tarafından, s&ouml;z konusu birimlerin faaliyet ama&ccedil;larına uygun olarak kullanılmaktadır ve tavsiye
        edilmesi durumunda başka grup şirketleriyle, bilgilerin teyit edilmesi amacıyla referans g&ouml;sterilen
        kişilerle ve departman y&ouml;neticilerinin &Ccedil;alışan Adaylarıyla (g&ouml;r&uuml;şmeleri (
        ger&ccedil;ekleştirmesi amacıyla departmanlar (arasında paylaşılmaktadır. Kişisel verileriniz yukarıda
        belirtilen ama&ccedil;larla işlenmektedir.&nbsp;
      </li>
      <li>
        Gerektiği hallerde savunma hakkımızı kullanabilmemiz i&ccedil;in avukatlarımızla ve talep gelmesi halinde
        mahkemelerle paylaşılabilir.
      </li>
    </ul>
    <p>
      Kişisel verileriniz, ilgili mevzuatta belirtilen veya işlendikleri ama&ccedil; i&ccedil;in gerekli olan ve her
      halde kanuni zamanaşımı s&uuml;releri kadar muhafaza edilecektir.
      <br />
      <br />
    </p>
    <p>
      <strong>KİŞİSEL VERİLERİNİZİN YURT İ&Ccedil;İNDEKİ &Uuml;&Ccedil;&Uuml;NC&Uuml; KİŞİLERLE PAYLAŞILMASI</strong>
    </p>
    <p>
      Şirket, Veri Sorumlusu sıfatı ile işlediği &ccedil;alışan adaylarına ait kişisel verileri; işe alım s&uuml;recinde
      rol alan ilgili departman y&ouml;neticileri, &ccedil;alışan adayının paylaştığı referanslar ile &ccedil;alışan
      niteliklerinin uygunluğunun tespiti amacıyla paylaşmaktadır.&nbsp;
      <br />
      Aynı zamanda &ccedil;alışan adayının istihdamıyla ilgili uygun pozisyonun değerlendirilmesi amacıyla zaman zaman
      grup şirketlerine aday CV&apos;leri y&ouml;nlendirilmektedir. Bu kapsamda Cimri Bilgi Teknolojileri ve Sistemleri;
      Kariyernet A.Ş; Lityum Yazılım A.Ş; Endeksa Teknoloji A.Ş; Sigortamnet A.Ş.; Arabam com A.Ş.; Hangisi İnternet
      A.Ş.; Neredekal A.Ş. ; Chemorbis A.Ş.; Steelorbis A.Ş.; Hangikredi Sigorta A.Ş. ; Say Holding A.Ş.; Mesay
      Gayrimenkul A.Ş.; Olgun &Ccedil;elik A.Ş.; Tuzla Gayrimenkul A.Ş ile de paylaşım yapılabilmektedir. Talep gelmesi
      durumunda verileriniz hukuki y&uuml;k&uuml;ml&uuml;l&uuml;klerimiz kapsamında mahkemelere aktarılabilmektedir.
    </p>
    <p>
      İşyeri g&uuml;venliği amacıyla giriş-&ccedil;ıkışların denetlenmesi i&ccedil;in bina g&uuml;venliğine
      bilgi&nbsp;&nbsp;aktarabiliyoruz.
    </p>
    <p>
      Kişisel veriler, alıcı gruplarla basılı kopya ve elektronik posta yoluyla paylaşılmaktadır. Google firmasına ait
      G-mail elektronik posta hizmeti altyapısının kullanılması sebebiyle g&ouml;nderilen ve alınan elektronik
      postaların d&uuml;nyanın &ccedil;eşitli yerlerinde bulunan veri merkezlerinde tutulması ve bu durumda kişisel
      verilerin yurt dışına aktarılması s&ouml;z konusudur. &ldquo;Server&rdquo;ları yurt dışında bulunan veri
      sorumlularından/veri işleyenlerden temin edilen saklama hizmetlerinin faaliyetleri de Kanunun 9. Maddesi
      h&uuml;k&uuml;mlerine uygun olarak ger&ccedil;ekleştirilir.
      <br />
      <br />
      <br />
      <strong>HAKLARINIZ</strong>
    </p>
    <p>
      KVKK&apos;nın 11. maddesi gereği bize şahsen, kimliğinizi ispat etmeniz kaydıyla, kişisel verileriniz ile ilgili;
    </p>
    <ul>
      <li>
        Şirket&apos;in hakkınızda kişisel veri işleyip işlemediğini &ouml;ğrenmek, eğer işlemişse, buna ilişkin bilgi
        talep etmek,
      </li>
      <li>Kişisel verilerinizin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığı &ouml;ğrenmek,</li>
      <li>
        Kişisel verilerin yurti&ccedil;i veya yurtdışına aktarılıp aktarılmadığı ve kimlere aktarıldığını &ouml;ğrenmek
        haklarına sahipsiniz.
      </li>
    </ul>
    <p>
      Ayrıca, Şirket&apos;ten yanlış ve eksik kişisel verilerinizin d&uuml;zeltilmesini ve verilerinin aktarıldığı veya
      aktarılmış olabileceği alıcıların bilgilendirilmesini talep etme hakkınız vardır.
    </p>
    <p>
      Kişisel verilerinizin KVKK madde 7&apos;de &ouml;ng&ouml;r&uuml;len şartlar &ccedil;er&ccedil;evesinde
      verilerinizin imha edilmesini (silinmesini, yok edilmesini veya anonim hale getirilmesini) Şirketten talep
      edebilirsiniz. Aynı zamanda verilerin aktarıldığı veya aktarılabileceği 3. kişilerin imha ve/veya d&uuml;zeltme
      talebiniz ile ilgili bilgilendirilmesini talep edebilirsiniz. Ancak imha ve d&uuml;zeltme talebinizi
      değerlendirerek hangi y&ouml;ntemin uygun olduğu somut olayın koşullarına g&ouml;re tarafımızca
      değerlendirilecektir. Bu bağlamda se&ccedil;tiğimiz imha y&ouml;ntemini neden se&ccedil;tiğimiz ile ilgili bizden
      her zaman bilgi talep edebilirsiniz.
    </p>
    <p>
      M&uuml;nhasıran bir otomatik sistem kullanılarak oluşturulmuş kişisel veri analizinizin sonu&ccedil;larına bu
      sonu&ccedil;lar &ccedil;ıkarlarınıza aykırıysa itiraz edebilirsiniz.
    </p>
    <p>
      Kişisel verilerinizin kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız halinde zararın giderilmesini
      talep edebilirsiniz.
      <br />
      <br />
      Başvurunuzda yer alan talepleriniz, talebin niteliğine g&ouml;re en ge&ccedil; otuz g&uuml;n i&ccedil;inde
      &uuml;cretsiz olarak sonu&ccedil;landırılacaktır. Ancak, işlemin Şirket i&ccedil;in ayrıca bir maliyeti
      gerektirmesi h&acirc;linde, Kişisel Verileri Koruma Kurulu tarafından belirlenen tarifedeki &uuml;cret alınabilir.
    </p>
    <p>
      Kişisel verilerinizin işlenmesi ile ilgili hususlarda başvurularınızı kimliğinizi ispatlamak suretiyle aşağıda
      bulunan mail adresinden yapabilirsiniz. Başvuruyu, Elektronik posta (KEP) adresi ile&nbsp;g&uuml;venli elektronik
      imza, mobil imza ya da bize daha &ouml;nce bildirdiğiniz ve kayıtlarımızda yer alan elektronik posta adresinizi
      kullanmak suretiyle Şirketimize iletmeniz gerekmektedir.&nbsp;
      <br />
      Şirket tarafından talebinizin mahiyetine ve başvuru y&ouml;nteminize g&ouml;re Şirket tarafından başvurunun size
      ait olup olmadığının belirlenmesi ve b&ouml;ylece haklarınızı koruyabilmek amacıyla ek doğrulamalar (kayıtlı
      telefonunuza mesaj g&ouml;nderilmesi, aranmanız gibi) istenebilir. &Ouml;rneğin Şirkette kayıtlı olan e-posta
      adresiniz aracılığıyla başvuru yapmanız halinde Şirkette kayıtlı başka bir iletişim y&ouml;ntemini kullanarak size
      ulaşabilir ve başvurunun size ait olup olmadığının teyidini isteyebiliriz.
    </p>
    <p>
      <br />
      Kişisel verilerin korunması kanunu hakkında bilgilendirmeyi okudum.
    </p>
    <p>
      <strong>İLETİŞİM BİLGİLERİ</strong>
    </p>
    <p>İletişim linki:&nbsp;ejinternet@hs01.kep.tr</p>
    <p>
      Adres:&nbsp;Saray Mah. Akg&uuml;l Sokak No:1C K:10 ENPLAZA &Uuml;MRANİYE/İSTANBUL
      <br />
      <br />
    </p>
  </div>
);

export default EmployeeCandidateDisclosure;
